










import { Component, Vue, Prop } from "vue-property-decorator";
import { PopularCardData, BiCardType } from "@/types";

@Component({
  name: "BiPopularCard"
})
export default class Funnel extends Vue {
  @Prop({ type: Object, required: true }) card!: PopularCardData;
  @Prop({ type: String, required: true }) type!: BiCardType;

  goTo() {
    if(this.type === 'case') {
      this.$gtag.event(`BI_expert_case-${ this.card.id }-${ this.card.title }`)
      window.open(`${process.env.VUE_APP_FRONT_END_APP_URL}/expert-case/${this.card.id}`, '_blank')
    }
    else {
      this.$gtag.event(`BI_expert_event-${ this.card.id }-${ this.card.title }`)
    }
  }
}
